import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import moment from 'moment';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceStudent } from '../../hooks/useAuthorizedRequestForStudent';
import { CModal } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import VidyaUpasna from "../../assets/VidyaUpasna.jpg";
import { GeneratePdf } from '../../components/GeneratePdf';
import { Loader } from '../../components/ModalsCommonFunctions';
import separator_line from "../../assets/separator_line.png";
import { getCurrentTime } from '../../components/CurrentTime';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { examDownloadReportFormValidation } from '../../validation/Validation';
import { ErrorMessage } from '../../validation/validationError';
import { ZodError } from 'zod';

const SectionExamDownloadReport = () => {
    const sectionMasterId = localStorage.getItem("sectionMasterId")
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosStudent = generateAxiosInstanceStudent()
    const [examNameList, setExamNameList] = useState([]);
    const [month, setMonth] = useState(moment().format('YYYY-MM'));
    const [start_date, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [end_date, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    const [exam_id, setExam_id] = useState("");
    const [examDownloadReport, setExamDownloadReport] = useState([]);
    const [error, setError] = useState([])

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getExamMasterList()
    }, [month]);

    const handleMonth = (newMonth) => {
        setMonth(newMonth ? newMonth.format('YYYY-MM') : '');
        setStartDate(newMonth.startOf('month').format('YYYY-MM-DD'));
        setEndDate(newMonth.endOf('month').format('YYYY-MM-DD'));

        if (newMonth.format('YYYY-MM').trim().length !== 0) {
            setError(prevErrors => prevErrors.filter(error => error.path[0] !== 'month'));
        }
    };

    const handleExamChange = (e) => {
        const { name, value } = e.target;
        setExam_id(value);

        if (value.trim().length !== 0) {
            setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const getExamMasterList = async () => {
        const apiUrl = `/assigned-exams?section_id=${sectionMasterId}&start_date=${start_date}&end_date=${end_date}`;

        try {
            const response = await authorizedAxiosSection.get(apiUrl);
            setExamNameList(response.data.data);
        } catch (error) {
            setExamNameList([])
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    };

    const getExamDownloadReport = async () => {
        const apiUrl = `/get-student-exam-download-report?section_id=${sectionMasterId}&exam_id=${exam_id}`;

        try {
            await examDownloadReportFormValidation.parseAsync({ month, exam_id })
            setError([]);
            setLoading(true);
            const response = await authorizedAxiosSection.get(apiUrl);
            setExamDownloadReport(response.data.result);
        } catch (error) {
            if (error instanceof ZodError) {
                setError(error.errors);
            } else {
                setExamDownloadReport([])
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
                console.error('Error fetching data:', errorMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    const handleInputReset = () => {
        setMonth(moment().format('YYYY-MM'));
        setStartDate(moment().startOf('month').format('YYYY-MM-DD'));
        setEndDate(moment().endOf('month').format('YYYY-MM-DD'));
        setExam_id("");
        setExamDownloadReport([]);
        setError([]);
    };

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Exam Deatils</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-pen"></i>Exam Download Report</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6 full_wrap">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Month</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={['year', 'month']}
                                                            value={dayjs(month)}
                                                            onChange={handleMonth}
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                    <ErrorMessage errors={error} field="month" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="exam_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Exam Name:</label>
                                                    <select class="form-select" aria-label="Default select example" name='exam_id' onChange={handleExamChange} value={exam_id}>
                                                        <option selected value={''} disabled>Select Type</option>
                                                        {
                                                            examNameList?.map((exam) => {
                                                                return <option value={exam.ExamMaster.id}>{exam.ExamMaster.exam_name}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="exam_id" />
                                                </div>

                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    <button className="btn btn-primary" type="button" onClick={getExamDownloadReport}>Show</button>
                                                    <button className="btn btn-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-grid gap-2 mt-2">
                                            <div class="tab-content rounded-bottom custom_table">
                                                <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" className='sl_no'>Sr. No.</th>
                                                                <th scope="col">Exam Name</th>
                                                                <th scope="col">Student Name</th>
                                                                <th scope="col">Contact Number</th>
                                                                <th scope="col">Class</th>
                                                                <th scope="col">Division</th>
                                                                <th scope="col">Download Count</th>
                                                                <th scope="col">Download Request Count</th>
                                                                <th scope="col">Last Download Request Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                examDownloadReport?.length > 0 ?
                                                                    examDownloadReport?.map((exam, index) => {
                                                                        return (
                                                                            <tr>
                                                                                <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                <td>{exam?.ExamMaster?.exam_name}</td>
                                                                                <td>{exam?.StudentMaster?.studentName}</td>
                                                                                <td>
                                                                                    {exam?.StudentMaster?.primaryContact}
                                                                                    {exam?.StudentMaster?.secondaryContact && (
                                                                                        <>
                                                                                            <br />
                                                                                            {exam?.StudentMaster?.secondaryContact}
                                                                                        </>
                                                                                    )}
                                                                                </td>
                                                                                <td>{exam?.StudentMaster?.instituteGradeMasterDetails?.gradeName}</td>
                                                                                <td>{exam?.StudentMaster?.instituteDivisionMasterDetails?.divisionName}</td>
                                                                                <td>{exam?.downloadCount}</td>
                                                                                <td>{exam?.downloadRequestCount}</td>
                                                                                <td>{exam?.downloadRequestStatus ? exam?.downloadRequestStatus : 'No current request'}</td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    (<tr>
                                                                        <th colspan={"100%"} style={{ textAlign: 'center' }}>No Exam Download Report Available</th>
                                                                    </tr>)
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionExamDownloadReport;

